import React from "react";

const CrazyEggTrackers = () => {
  if (
    process.env.REACT_APP_USE_TRACKERS &&
    process.env.REACT_APP_USE_TRACKERS.toString() === "true"
  ) {
    if (
      Array.from(document.scripts).filter(
        (item) => item.src.indexOf("crazyegg") > 0
      ).length === 0
    ) {
      const script = document.createElement("script");
      script.src = "//script.crazyegg.com/pages/scripts/0121/7089.js";
      script.id = "hs-script-loader";
      script.type = "text/javascript";
      script.async = true;

      if (document.head) {
        document.head.appendChild(script);
      }
    }
  }
  return <></>;
};

export default CrazyEggTrackers;
